import Vue from "vue"
import Router from "vue-router"
Vue.use(Router)

/* Layout */
import Layout from "@/layout"
/**
 * hidden: true                   如果设置为true，则不显示
 * alwaysShow: true               一直显示
 * redirect: noRedirect           如果设置为noRedirect，则面包屑中不会重定向
 * name:'router-name'             这个name 是用在 <keep-alive> (必须设置！)
 * meta : {
    roles: ['admin','editor']    控制页面权限角色（可以设置多个角色）
    title: 'title'               字面意思
    icon: 'svg-name'/'el-icon-x' 图标
    breadcrumb: false            不在面包屑显示
    activeMenu: '/example/list'  暂时没啥用
  }
 */

/**
 * 公共路由
 * 是个人都可以访问的页面
 */
export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index_new_0807.vue"),
    meta: {
      title: "登录",
      icon: "el-icon-s-help"
    },
    hidden: true
  },
  {
    hidden: true,
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    meta: {
      title: "跳板",
      icon: "el-icon-s-help",
      breadcrumb: false
    },
    children: [
      {
        hidden: true,
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/views/dashboard/index"),
        meta: { title: "跳板", icon: "dashboard", tagHide: true }
      }
    ]
  },
  {
    hidden: true,
    path: "/resetPsw",
    name: "resetPsw",
    component: () => import("@/views/reset-psw/index"),
    meta: {
      title: "修改密码",
      icon: "example"
    }
  },
  {
    path: "/apps",
    name: "APP",
    component: Layout,
    meta: { title: "apps" },
    children: [
      {
        path: "/masterData/",
        name: "MasterData",
        component: () => import("@/views/mdm/index.vue"),
        meta: {}
      },
      {
        path: "/userData/",
        name: "WCT",
        component: () => import("@/views/wct/index.vue"),
        meta: {}
      },
      {
        path: "/voyager/",
        name: "Voyager",
        component: () => import("@/views/voyager/index.vue"),
        meta: {}
      },
      {
        path: "/product/",
        name: "ProductCenter",
        component: () => import("@/views/product-center/index.vue"),
        meta: {}
      },
      {
        path: "/advert/",
        name: "Advert",
        component: () => import("@/views/advert/index.vue"),
        meta: {}
      },
      {
        path: "/count/",
        name: "SystemCount",
        component: () => import("@/views/system-data-center/index.vue"),
        meta: {}
      },
      {
        path: "/cdp/",
        name: "Cdp",
        component: () => import("@/views/cdp/index.vue"),
        meta: {}
      },
      {
        path: "/customCenter/",
        name: "CustomerCenter",
        component: () => import("@/views/customer-center/index.vue"),
        meta: {}
      },
      {
        path: "/orderCenter/",
        name: "OrderCenter",
        component: () => import("@/views/order-center/index.vue"),
        meta: {}
      },
      {
        path: "/logistics/",
        name: "LogisticsCenter",
        component: () => import("@/views/logistics-center/index.vue"),
        meta: {}
      },
      {
        path: "/plm/",
        name: "Plm",
        component: () => import("@/views/plm/index.vue"),
        meta: {}
      },
      {
        path: "/budget/",
        name: "budget",
        component: () => import("@/views/budget/index.vue"),
        meta: {}
      },
      {
        path: "/scm/",
        name: "Scm",
        component: () => import("@/views/scm/index.vue"),
        meta: {}
      },
      {
        path: "/material/",
        name: "Material",
        component: () => import("@/views/material-center/index.vue"),
        meta: {}
      },
      {
        path: "/ta/",
        name: "TA",
        component: () => import("@/views/tata/index.vue"),
        meta: {}
      },
      {
        path: "/financialCenter/",
        name: "FinancialCenter",
        component: () => import("@/views/financial-center/index.vue"),
        meta: {}
      },
      {
        path: "/supplyChainManagement/",
        name: "SupplyChainManagement",
        component: () => import("@/views/supply-chain-management/index.vue"),
        meta: {}
      }
    ]
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    meta: {
      title: "404",
      icon: "el-icon-s-help"
    },
    hidden: true
  }
]
/**
 * 异步路由
 * 需要根据用户角色动态加载的路由
 */
export const asyncRoutes = [
  {
    path: "*",
    redirect: "/404",
    meta: {
      title: "404",
      icon: "el-icon-share"
    },
    hidden: true
  }
]

const createRouter = () =>
  new Router({
    mode: "history", // 服务器要支持，暂不设置
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// 重置路由
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
  router.options.routes = []
}

export default router
